import React, { useState, useRef, useEffect } from 'react';
import api from '../utils/api';

export default function MentionInput({ onSubmit, placeholder = 'Write a comment... Use @ to mention someone' }) {
  const [text, setText] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [mentionedUsers, setMentionedUsers] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const textareaRef = useRef();

  useEffect(() => {
    if (query.length > 0) {
      const timer = setTimeout(async () => {
        try {
          const { data } = await api.get(`/api/users/search?q=${encodeURIComponent(query)}`);
          setUsers(data.users);
          setShowDropdown(data.users.length > 0);
        } catch { setShowDropdown(false); }
      }, 200);
      return () => clearTimeout(timer);
    } else {
      setShowDropdown(false);
    }
  }, [query]);

  function handleChange(e) {
    const val = e.target.value;
    setText(val);
    // Remove mentions whose @name is no longer in the text
    setMentionedUsers(prev => prev.filter(u => val.includes(`@${u.name}`)));
    // Check if user is typing @mention
    const cursor = e.target.selectionStart;
    const textBefore = val.substring(0, cursor);
    const atMatch = textBefore.match(/@(\w*)$/);
    if (atMatch) {
      setQuery(atMatch[1]);
    } else {
      setShowDropdown(false);
    }
  }

  function selectUser(user) {
    const cursor = textareaRef.current.selectionStart;
    const textBefore = text.substring(0, cursor);
    const textAfter = text.substring(cursor);
    const atIdx = textBefore.lastIndexOf('@');
    const newText = textBefore.substring(0, atIdx) + `@${user.name} ` + textAfter;
    setText(newText);
    if (!mentionedUsers.find(u => u.id === user.id)) {
      setMentionedUsers(prev => [...prev, user]);
    }
    setShowDropdown(false);
    textareaRef.current.focus();
  }

  async function handleSubmit() {
    if (!text.trim() || submitting) return;
    setSubmitting(true);
    try {
      await onSubmit(text, mentionedUsers.map(u => u.id));
      setText('');
      setMentionedUsers([]);
    } catch (err) {
      console.error('Comment submit error:', err);
    } finally {
      setSubmitting(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      handleSubmit();
    }
  }

  return (
    <div className="mention-input-container">
      {showDropdown && (
        <div className="mention-dropdown">
          {users.map(u => (
            <div key={u.id} className="mention-option" onClick={() => selectUser(u)}>
              <strong>{u.name}</strong>
              <span style={{ marginLeft: '8px', color: 'var(--text-light)', fontSize: '12px' }}>{u.email}</span>
            </div>
          ))}
        </div>
      )}
      <textarea
        ref={textareaRef}
        value={text}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
        <button className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={!text.trim() || submitting}>
          {submitting ? 'Posting...' : 'Post Comment'}
        </button>
      </div>
    </div>
  );
}
